import { Reminder } from './models';

export interface ReminderResponse {
    ID: number;
    NoteID: number; 
    Note: string;
    FollowUpDate: string;
    IsResolved: boolean;
    CreatedDate: string;
    CreatedByUserID: number;
    LastModifiedByUserID?: number;
    LastModifiedDate?: string;
    Priority?: number;
    CompanyID?: number;
    ParentReminderID?: number;
    DocumentID?: number;
    ParentReminder?: ReminderResponse;
    CreatedByUserName: string;
    LastModifiedByUserName?: string;
    CompanyName?: string;
}

export function toReminder(response: ReminderResponse | any): Reminder {
    if (!response) {
        return null;
    }
    
    const reminder: Reminder = {
        id: response.ID !== undefined ? response.ID : response.id,
        noteID: response.noteID !== undefined ? response.noteID : 0,
        note: response.Note || response.note || '',
        followUpDate: response.FollowUpDate || response.followUpDate ? 
            new Date(response.FollowUpDate || response.followUpDate) : new Date(),
        isResolved: response.IsResolved !== undefined ? response.IsResolved : 
            (response.isResolved !== undefined ? response.isResolved : false),
        createdDate: response.CreatedDate || response.createdDate ? 
            new Date(response.CreatedDate || response.createdDate) : new Date(),
        createdByUserID: response.CreatedByUserID !== undefined ? response.CreatedByUserID : 
            (response.createdByUserID !== undefined ? response.createdByUserID : 0),
        createdByUserName: response.CreatedByUserName || response.createdByUserName || '',
        lastModifiedByUserID: response.LastModifiedByUserID !== undefined ? response.LastModifiedByUserID : 
            response.lastModifiedByUserID,
        lastModifiedDate: (response.LastModifiedDate || response.lastModifiedDate) ? 
            new Date(response.LastModifiedDate || response.lastModifiedDate) : undefined,
        lastModifiedByUserName: response.LastModifiedByUserName || response.lastModifiedByUserName,
        priority: response.Priority !== undefined ? response.Priority : response.priority,
        companyID: response.CompanyID !== undefined ? response.CompanyID : response.companyID,
        parentReminderID: response.ParentReminderID !== undefined ? response.ParentReminderID : 
            response.parentReminderID,
        companyName: response.CompanyName || response.companyName,
        documentID: response.DocumentID !== undefined ? response.DocumentID : response.documentID
    };
    
    try {
        if (response.ParentReminder || response.parentReminder) {
            const parentData = response.ParentReminder || response.parentReminder;
            
            if (typeof parentData === 'object' && parentData !== null) {
                reminder.parentReminder = toReminder(parentData);
            } else if (typeof parentData === 'string' && parentData.trim() !== '') {
                reminder.parentReminder = {
                    id: response.ParentReminderID || response.parentReminderID || 0, 
                    noteID: 0, 
                    note: parentData,
                    followUpDate: new Date(),
                    isResolved: false,
                    createdDate: new Date(),
                    createdByUserID: 0,
                    createdByUserName: ''
                };
            }
        } 
        else if (response.ParentReminderID || response.parentReminderID) {
            const parentId = response.ParentReminderID || response.parentReminderID;
            
            reminder.parentReminder = {
                id: parentId,
                noteID: 0,
                note: 'Loading parent reminder...',
                followUpDate: new Date(),
                isResolved: false,
                createdDate: new Date(),
                createdByUserID: 0,
                createdByUserName: ''
            };
        }
    } catch (error) {
        console.error('Error processing parent reminder:', error);
    }
    
    return reminder;
}



// WEBPACK FOOTER //
// ./src/app/core/components/reminders/models/responses.ts